export default __webpack_public_path__ + "static/media/HEAT-WAVE.6c3635ec.png";